var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1669 41.2302C9.79687 41.2302 0.546875 31.9801 0.546875 20.6101C0.546875 9.24011 9.79687 -0.00976562 21.1669 -0.00976562C32.5369 -0.00976562 41.7869 9.24011 41.7869 20.6101C41.7869 31.9801 32.5369 41.2302 21.1669 41.2302ZM21.1669 0.900146C10.2969 0.900146 1.45691 9.74011 1.45691 20.6101C1.45691 31.4801 10.2969 40.3201 21.1669 40.3201C32.0369 40.3201 40.877 31.4801 40.877 20.6101C40.877 9.74011 32.0369 0.900146 21.1669 0.900146Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0297 15.2197C15.4656 15.2197 16.6298 14.0556 16.6298 12.6196C16.6298 11.1837 15.4656 10.0195 14.0297 10.0195C12.5937 10.0195 11.4297 11.1837 11.4297 12.6196C11.4297 14.0556 12.5937 15.2197 14.0297 15.2197Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0671 16.9492H12.9972C12.3731 16.9492 11.8672 17.455 11.8672 18.0791V28.8091C11.8672 29.4332 12.3731 29.9392 12.9972 29.9392H15.0671C15.6912 29.9392 16.1971 29.4332 16.1971 28.8091V18.0791C16.1971 17.455 15.6912 16.9492 15.0671 16.9492Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9062 21.7097V29.0696C30.9062 29.5496 30.5163 29.9397 30.0363 29.9397H27.4363C26.9563 29.9397 26.5663 29.5496 26.5663 29.0696V23.0098C26.5663 21.8198 25.5963 20.8496 24.4062 20.8496C23.2162 20.8496 22.2463 21.8198 22.2463 23.0098V29.0696C22.2463 29.5496 21.8563 29.9397 21.3763 29.9397H18.7762C18.2962 29.9397 17.9062 29.5496 17.9062 29.0696V17.8196C17.9062 17.3396 18.2962 16.9497 18.7762 16.9497H21.3763C21.8563 16.9497 22.2463 17.3396 22.2463 17.8196V18.3696C23.1163 17.2496 24.5462 16.5195 26.1462 16.5195C28.5362 16.5195 30.9062 18.2497 30.9062 21.7097Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.8e23884227c62b9dd57358baa6ef563d.svg";
export { ForwardRef as ReactComponent };